import React from 'react'

class Footer extends React.Component {
  render(){
    return(
      <footer>
        <p> Keep up with all the topics that matter to you, all in one place.
        Powered by <a href={'http://newsapi.org'} target ="_blank" rel="noopener noreferrer">NEWS API</a> </p>
      </footer>
    )
  }
}
export default Footer
